import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function CheckIcon(props) {
  return (
    <SvgIcon {...props}>
      <g transform="matrix(0.01644068,0,0,-0.01644068,2.133178,21.864407)">
        <path d="M465 477l571 571q8 8 18 8t17 -8l177 -177q8 -7 8 -17t-8 -18l-783 -784q-7 -8 -17.5 -8t-17.5 8l-384 384q-8 8 -8 18t8 17l177 177q7 8 17 8t18 -8l171 -171q7 -7 18 -7t18 7z" />
      </g>
    </SvgIcon>
  );
}
